<p>
  reset-user works!
</p>
